import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByDimension state domain
 */

const selectWidgetResultByDimensionDomain = (state) =>
  state.get("widgetResultByDimension", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectWidgetResultByDimensionDomain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectWidgetResultByDimensionDomain, (state) =>
    state.get("dimensionsDrillDown")
  )

export const makeSelectDivisions = () =>
  createSelector(selectWidgetResultByDimensionDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectShowDimensionBenchmark = () =>
  createSelector(selectWidgetResultByDimensionDomain, (state) =>
    state.get("showDimensionBenchmark")
  )

/**
 * Default selector used by WidgetResultByDimension
 */

const makeSelectWidgetResultByDimension = () =>
  createSelector(selectWidgetResultByDimensionDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDimension
export { selectWidgetResultByDimensionDomain }
